import { ReactComponent as CloseIcon } from 'assets/icons/close-badge-icon.svg';
import { fern } from 'shared/config/Colors';
import { Badge } from './Badge';

export const NewCollaborationBadge = ({
  onClose,
}: {
  onClose?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}) => {
  return (
    <Badge bgColor={fern}>
      NEW COLLABORATION{onClose && <CloseIcon onClick={(e) => onClose(e)} />}
    </Badge>
  );
};

NewCollaborationBadge.defaultProps = {
  onClose: undefined,
};
